export default __webpack_public_path__ + "static/media/18_LeftToRightSquares_ZoomOut.57725e26.mp4";